import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { MessageSquare } from "lucide-react";

const statusColors = {
    PENDING: "bg-amber-50 text-amber-700 border-amber-200",
    VIEWED: "bg-blue-50 text-blue-700 border-blue-200",
    SHORTLISTED: "bg-indigo-50 text-indigo-700 border-indigo-200",
    ACCEPTED: "bg-emerald-50 text-emerald-700 border-emerald-200",
    REJECTED: "bg-rose-50 text-rose-700 border-rose-200",
    WITHDRAWN: "bg-gray-50 text-gray-700 border-gray-200",
};

export default function ProfessionalApplications() {
    const [apps, setApps] = useState([]);
    const load = async () => {
        const { data } = await api.get("/applications");
        setApps(data.data || []);
    };
    useEffect(() => { load(); }, []);

    const withdraw = async (id) => {
        await api.patch(`/applications/${id}`, { status: "WITHDRAWN" });
        load();
    };

    return (
        <div className="max-w-5xl mx-auto">
            <h1 className="font-display text-3xl font-bold tracking-tight">Le mie candidature</h1>
            <p className="text-sm text-[#5C5C5C] mt-1 mb-6">{apps.length} in totale</p>
            <div className="space-y-3">
                {apps.length === 0 && (
                    <div className="hl-card p-10 text-center text-[#5C5C5C]">Nessuna candidatura ancora.</div>
                )}
                {apps.map((a) => (
                    <div key={a.id} className="hl-card p-5 flex items-center justify-between gap-4" data-testid={`app-row-${a.id}`}>
                        <div>
                            <div className="font-display font-bold">{a.job_title}</div>
                            <div className="text-xs text-[#5C5C5C]">Candidatura del {new Date(a.created_at).toLocaleDateString("it-IT")} · Match {a.match_score}%</div>
                        </div>
                        <div className="flex items-center gap-3">
                            <Badge variant="outline" className={statusColors[a.status]} data-testid={`app-status-${a.id}`}>{a.status}</Badge>
                            <Link to="/app/chat"><Button variant="ghost" size="icon"><MessageSquare className="w-4 h-4" /></Button></Link>
                            {a.status === "PENDING" && (
                                <Button size="sm" variant="outline" onClick={() => withdraw(a.id)} data-testid={`withdraw-${a.id}`}>Ritira</Button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
